import type {
  ActiveUserRiskAnalysesAssetsForCreate,
  ActiveUserRiskAnalysesAssetsForCreateDTO,
} from './activeUserRiskAnalysesAssetsForCreate.types';

// eslint-disable-next-line import/prefer-default-export
export const parseAllActiveUserRiskAnalysesAssetsForCreateForFE = (
  dto: ActiveUserRiskAnalysesAssetsForCreateDTO,
): ActiveUserRiskAnalysesAssetsForCreate => dto.assets.map(({ id, name }) => ({ label: name, key: id }));
